(() => {
  'use strict';
  if (window.vbPurchaseExtrasLoaded) return;
  window.vbPurchaseExtrasLoaded = true;
  const instances = new Map();
  function mount(product) {
    if (instances.has(product)) return;
    const abort = new AbortController(), signal = abort.signal;
    const listen = (node, event, action, options = {}) => node?.addEventListener(event, action, { ...options, signal });
    const updateStock = () => {
      const selected = product.querySelector('input[name="vb_variant"]:checked');
      product.querySelectorAll('[data-vb-stock-variant]').forEach(node => {
        node.hidden = !selected || selected.disabled || node.dataset.vbStockVariant !== selected.value;
      });
    };
    updateStock();
    listen(product, 'change', event => {
      if (event.target.matches('input[name="vb_variant"]')) updateStock();
    });
    const dialog = product.querySelector('[data-vb-story-dialog]');
    if (!dialog) { instances.set(product, () => abort.abort()); return; }
    const slot = dialog.querySelector('[data-vb-story-slot]');
    const title = dialog.querySelector('[data-vb-story-title]');
    const caption = dialog.querySelector('[data-vb-story-caption-output]');
    const error = dialog.querySelector('[data-vb-story-error]');
    let opener = null, closingByScroll = false, openedY = 0, touchStart = null;
    const stop = () => {
      const video = slot.querySelector('video');
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        video.load();
      }
      slot.replaceChildren();
      error.hidden = true;
    };
    const close = (scroll = false) => {
      if (!dialog.open) return;
      closingByScroll = scroll;
      stop();
      dialog.close();
    };
    listen(product, 'click', event => {
      const trigger = event.target.closest('[data-vb-story-open]');
      if (!trigger || !product.contains(trigger)) return;
      const story = trigger.closest('.vb-story');
      const template = story.querySelector('[data-vb-story-media]');
      if (!template?.content.querySelector('video') || !dialog.showModal) return;
      stop();
      opener = trigger;
      closingByScroll = false;
      title.textContent = trigger.querySelector('.vb-story-name').textContent;
      caption.textContent = story.querySelector('[data-vb-story-caption]').content.textContent.trim();
      caption.hidden = !caption.textContent;
      slot.append(template.content.cloneNode(true));
      const video = slot.querySelector('video');
      video.addEventListener('error', () => { if (dialog.open) error.hidden = false; }, { once: true });
      dialog.showModal();
      openedY = window.scrollY;
      const playing = video.play();
      if (playing?.catch) playing.catch(() => {});
    });
    listen(dialog.querySelector('[data-vb-story-close]'), 'click', () => close());
    listen(dialog, 'click', event => { if (event.target === dialog) close(); });
    listen(dialog, 'cancel', event => { event.preventDefault(); close(); });
    listen(dialog, 'close', () => {
      stop();
      if (!closingByScroll && opener?.isConnected) opener.focus({ preventScroll: true });
      touchStart = null;
    });
    listen(dialog, 'wheel', event => {
      if (Math.abs(event.deltaY) > 4 && !event.target.closest('.vb-story-caption')) close(true);
    }, { passive: true });
    listen(dialog, 'touchstart', event => {
      const touch = event.touches[0];
      const video = event.target.closest('video');
      const bounds = video?.getBoundingClientRect();
      const onControls = bounds && touch.clientY > bounds.bottom - 64;
      touchStart = event.touches.length === 1 && !onControls && !event.target.closest('button,.vb-story-caption')
        ? { x: touch.clientX, y: touch.clientY } : null;
    }, { passive: true });
    listen(dialog, 'touchmove', event => {
      if (!touchStart || event.touches.length !== 1) return;
      const touch = event.touches[0], dy = Math.abs(touch.clientY - touchStart.y);
      if (dy > 38 && dy > Math.abs(touch.clientX - touchStart.x) * 1.4) close(true);
    }, { passive: true });
    listen(dialog, 'touchend', () => { touchStart = null; }, { passive: true });
    listen(window, 'scroll', () => {
      if (dialog.open && Math.abs(window.scrollY - openedY) > 16) close(true);
    }, { passive: true });
    listen(document, 'visibilitychange', () => { if (document.hidden) close(); });
    instances.set(product, () => { close(); stop(); abort.abort(); });
  }
  function boot(root = document) {
    if (root.matches?.('[data-vb-product]')) mount(root);
    root.querySelectorAll('[data-vb-product]').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [product, destroy] of instances) {
      if (event.target === product || event.target.contains(product)) { destroy(); instances.delete(product); }
    }
  });
})();
